import React from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { REQUEST_ACTIONS } from '../../Constants/Actions.constants';
import { Route } from '~/Constants/Routes.constants';
import { useLanguage } from '../../Hooks/useLanguage';
import { EmailFormState } from './Forms/EmailForm.component';
import RecoverPasswordEmailComponent from './RecoverPasswordEmail.component';
import {
  selectPasswordRecovery,
  requestResetPassword,
  ResetPasswordAction,
} from '../../store/auth';
import { selectErrors } from '../../store/app';
import { useNavigation } from '~/Hooks';

export const submitResetEmail = (resetAction: ResetPasswordAction) => (data: EmailFormState) =>
  resetAction({ password_reset: data });

export const useRecoverPasswordEmail = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { getSearchParams } = useNavigation();
  const resetRequestSuccess = useSelector(selectPasswordRecovery(REQUEST_ACTIONS.PASSWORD_RESET));
  const recoverError = useSelector(selectErrors(REQUEST_ACTIONS.PASSWORD_RESET));
  const resetAction = bindActionCreators(requestResetPassword, dispatch);
  const { returnUrl } = getSearchParams();

  const { t } = useLanguage();

  return {
    t,
    history,
    onEmailFormSubmit: submitResetEmail(resetAction),
    resetRequestSuccess,
    recoverError,
    returnUrl,
  };
};

const RecoverPasswordEmailContainer = () => {
  const {
    t,
    onEmailFormSubmit,
    resetRequestSuccess,
    recoverError,
    returnUrl,
  } = useRecoverPasswordEmail();
  return (
    <>
      {resetRequestSuccess && (
        <Redirect
          to={`${Route.RECOVER_PASSWORD_SUCCESS}${returnUrl ? `?returnUrl=${returnUrl}` : ''}`}
        />
      )}
      <RecoverPasswordEmailComponent
        onSubmitResetEmail={onEmailFormSubmit}
        recoverError={recoverError}
        t={t}
      />
    </>
  );
};

export default RecoverPasswordEmailContainer;
